import React from 'react';
import { SelectAll } from 'ui/common/select-all/select-all';
import { ComplexValue } from 'ui/common/types';
import { SelectItem } from './types';

interface SelectAllSectionProps {
  textSelectAll: string;
  textClearAll: string;

  isSearch: boolean;
  isRoot: boolean;

  valueItems: SelectItem[];
  returnedOptions: ComplexValue<number>[];
  readOnlyItemIds?: number[];
  leafNodeOnly: boolean;
  allLevelsDescriptionPrefix: string;

  onChange: (items: SelectItem[]) => void;
}

export const SelectAllSection: React.FC<SelectAllSectionProps> = ({
  textSelectAll,
  textClearAll,
  isRoot,
  isSearch,
  valueItems,
  returnedOptions,
  leafNodeOnly,
  readOnlyItemIds,
  allLevelsDescriptionPrefix,
  onChange
}) => {

  const onSelectAll = (enabled: boolean) => {

    const current = (returnedOptions || [])
      .filter(item => !leafNodeOnly || !enabled || (item.descendants?.length ?? 0) === 0)
      .map<SelectItem>(item => allLevelsDescriptionPrefix
        ? { ...item, description: allLevelsDescriptionPrefix + item.description }
        : item
      );

    const merged = [...(valueItems || []), ...current];
    const excluded = merged.filter(m => !(current.map(f => f.value)).includes(m.value));
    const selected = [...excluded, ...current];
    const cleared = readOnlyItemIds?.length > 0
      ? valueItems.filter(item => readOnlyItemIds.includes(item.value as number))
      : (!isRoot || isSearch) ? excluded : excluded.filter(f => !!f.readOnly);

    onChange(enabled ? selected : cleared);
  };

  return <SelectAll
    textSelectAll={textSelectAll}
    textClearAll={textClearAll}
    onChange={onSelectAll} />;
};
